import { useQuery } from 'react-query';

import { queryOptions } from '../constants';
import { getTeeTimesRequest } from './index';

import type { AxiosError } from 'axios';
import type { UseQueryOptions } from 'react-query';
import type { TeeTimeResponse, ITeeTimeData } from './types';

const initialTeeTimes = { data: [], meta: { events: [] } } as TeeTimeResponse;

export function useTeeTimeList(
  courseId: string,
  date: string | null,
  startTime: string | null,
  cached: boolean,
  options?: UseQueryOptions<TeeTimeResponse, AxiosError | number, ITeeTimeData>
) {
  return useQuery({
    queryKey: ['getTeeTimes', courseId, date, cached, startTime],
    queryFn: () =>
      courseId && date
        ? getTeeTimesRequest(courseId, date, startTime ?? undefined, cached)
        : Promise.reject(initialTeeTimes),
    enabled: Boolean(courseId) && Boolean(date),
    initialData: initialTeeTimes,
    select: ({ data, meta }) => ({
      data: data
        .filter((teeTime) => teeTime.rates.length > 0)
        .map((teeTime) => ({
          ...teeTime,
          rates: teeTime.rates.reduce((prev, cur) => ({ ...prev, [cur.id]: cur }), {}),
        })),
      meta,
    }),
    ...queryOptions,
    ...options,
  });
}

